const translations = {
  title: 'Integrations',
  name: 'Name',
  service: 'Service',
  createdAt: 'Created at',
  updatedAt: 'Updated at',
  actions: 'Actions',
  modalTitle: 'Create new Integration',
  newIntegration: 'New Integration',
  selectAccount: 'Select an account',
  newIntegrationWithService: 'New Integration: {{service}}',
  tokenIntegrationDescription:
    '{{service}} does not support integration via redirect and login. It is necessary to copy the integration token(s) from the {{service}} platform and paste it in the form below:',
  select: 'Select',
  'widgets.segware.name': 'Integration with Segware',
  'widgets.segware.description': 'Create integration with Segware',
  'widgets.twilio.name': 'Integration with Twilio',
  'widgets.twilio.description': 'Create integration with Twilio',
  'widgets.chat_pro.name': 'Integration with ChatPro',
  'widgets.chat_pro.description': 'Create integration with ChatPro',
  'widgets.slack.name': 'Integration with Slack',
  'widgets.slack.description': 'Create integration with Slack',
  'widgets.google.name': 'Integration with Google Calendar',
  'widgets.google.description': 'Create integration with Google Calendar',
  'widgets.d4sign.name': 'Integration with d4sign',
  'widgets.d4sign.description': 'Create integration with D4sign',
  'segware.companyId': 'Company ID*',
  'segware.bearerToken': 'Bearer Token*',
  'd4sign.tokenApi': 'Token Api*',
  'd4sign.cryptKey': 'Crypt Key*',
  'twilio.accountSid': 'Account SID*',
  'twilio.authToken': 'Auth Token*',
  'twilio.myTwilioPhone': 'My Twilio phone*',
  'chat_pro.name': 'Integration name*',
  'chat_pro.instanceId': 'Instance ID*',
  'chat_pro.instanceToken': 'Instance Token*'
}

export default translations
